import functions from '@/functions.js';

export function createCustomTooltipHandler(energyUnitRef, dateFunction, numberFunction) {
  return function customTooltipHandler(context) {
    const tooltipModel = context.tooltip;

    if (tooltipModel.opacity === 0) {
      const existing = document.getElementById('custom-chartjs-tooltip');
      if (existing) existing.style.opacity = 0;
      return;
    }

    let tooltipEl = document.getElementById('custom-chartjs-tooltip');
    if (!tooltipEl) {
      tooltipEl = document.createElement('div');
      tooltipEl.id = 'custom-chartjs-tooltip';
      tooltipEl.style.position = 'absolute';
      tooltipEl.style.background = '#002445';
      tooltipEl.style.color = 'white';
      tooltipEl.style.padding = '8px 8px';
      tooltipEl.style.borderRadius = '4px';
      tooltipEl.style.pointerEvents = 'none';
      tooltipEl.style.transition = 'all .1s ease';
      tooltipEl.style.textAlign = 'center';
      tooltipEl.style.font = 'bold 14px sans-serif';
      tooltipEl.style.minWidth = '150px';
      tooltipEl.style.maxWidth = '220px';
      tooltipEl.style.boxSizing = 'border-box';
      tooltipEl.style.zIndex = 1000;
      document.body.appendChild(tooltipEl);
    } else {
      tooltipEl.innerHTML = '';
    }

    const index = tooltipModel.dataPoints[0].dataIndex;
    const labelX = tooltipModel.dataPoints[0].label;
    const datasets = tooltipModel.chart.data.datasets;

    const energyUnit = typeof energyUnitRef === 'function' ? energyUnitRef() : energyUnitRef.value || energyUnitRef;

    const primaryIndex = energyUnit !== 'kWh' ? 0 : 1;
    // const secondaryIndex = energyUnit === 'Euro' ? 1 : 0;

    const valVisible = datasets[primaryIndex].data[index];
    // const valHidden = datasets[secondaryIndex]?.data?.[index] ?? '-';

    const primaryUnit = energyUnit !== 'kWh' ? functions.currencies()[energyUnit] : 'kWh';
    const primaryFormat = energyUnit !== 'kWh' ? 'money' : 'power';
    // const secondaryUnit = energyUnit === 'Euro' ? 'kWh' : '€';
    // const secondaryFormat = energyUnit === 'Euro' ? 'power' : 'money';

    // tooltipEl.innerHTML = `
    //   <div style="font-size: 16px;">${valVisible} ${primaryUnit}</div>
    //   <div style="font-size: 12px; opacity: 0.8;">${labelX}</div>
    //   <div style="font-size: 12px; color: #ccc;">${valHidden} ${secondaryUnit}</div>
    // `;
    tooltipEl.innerHTML = `
      <div style="font-size: 28px; font-weight: 600; font-family: 'Titillium Web', sans-serif;line-height: 30px;">${numberFunction(valVisible,primaryFormat)} ${primaryUnit}</div>
      <div style="font-size: 23px; font-weight: 400; font-family: 'Titillium Web', sans-serif; line-height: 25px;">${dateFunction(new Date(labelX), 'shortNumeric')}</div>
    `;

    const line = document.createElement('div');
    line.style.position = 'absolute';
    line.style.bottom = '-10px';
    line.style.left = '50%';
    line.style.width = '2px';
    line.style.height = '10px';
    line.style.backgroundColor = '#002445';
    line.style.transform = 'translateX(-50%)';
    tooltipEl.appendChild(line);

    const chart = tooltipModel.chart;
    const canvasRect = chart.canvas.getBoundingClientRect();
    const tooltipX = canvasRect.left + window.pageXOffset + tooltipModel.caretX - tooltipEl.offsetWidth / 2;
    const tooltipY = canvasRect.top + window.pageYOffset + tooltipModel.caretY - tooltipEl.offsetHeight - 10;

    tooltipEl.style.left = `${tooltipX}px`;
    tooltipEl.style.top = `${tooltipY}px`;
    tooltipEl.style.opacity = 1;
  };
}
